import {
    CacheOptions,
    Configuration,
    IPublicClientApplication,
    PublicClientApplication,
} from "@azure/msal-browser";

// This is not a singleton. Don't try to make it one, even though it looks like that should be fine.
// It will break Organization SSO (i.e., Multi-tenant authentication).
// :(
export class MsalFactory {
    private instance: IPublicClientApplication | null = null;
    private cacheConfig: CacheOptions = {
        cacheLocation: "localStorage",
    };

    public async getOrCreateMsalInstance(
        config: Configuration
    ): Promise<IPublicClientApplication> {
        if (this.instance) {
            return this.instance;
        }

        this.instance = new PublicClientApplication({
            ...config,
            cache: { ...config.cache, ...this.cacheConfig },
        });

        await this.instance.initialize();

        return this.instance;
    }
}
